import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector, useShareFile } from '../../hooks'
import FilePermissions from './FilePermissions'
import { selectFile } from '../../app/file'
import { App } from '../../app/root'
import { Option } from './FilePermissions'
import { closeDialog, setDialog } from '../../app/dialog'
import {
  MappedFileTypes,
  StaticFileIconsConstant,
  googlePermissionsOptions,
  valueToVerb,
} from '../../constants'
import { zoomSdkApi } from '../../app/zoomSdkQueries'

const FileShareDialogGoogle = () => {
  const dispatch = useDispatch()
  const { screenName } = zoomSdkApi.endpoints.getUserContext.useQueryState(
    'getUserContext',
    {
      selectFromResult: (result) => ({
        screenName: result?.data?.screenName,
      }),
    }
  )
  const setShareFile = useShareFile()
  const selectedFile = useAppSelector(selectFile)!
  const [permission, setPermission] = useState<Option['value']>('editor')
  const iconType = selectedFile?.type
  const fileName = selectedFile?.name
  const fileUrl = selectedFile?.url
  const Icon = StaticFileIconsConstant['Google'][iconType]

  const onClose = () => {
    dispatch(closeDialog())
  }

  const handleGrant = async () => {
    if (screenName) {
      const shareFileData = {
        drive: 'Google' as App,
        fileId: selectedFile.id,
        fileUrl: selectedFile.url,
        fileName: selectedFile.name,
        accessType: permission,
        fileType: MappedFileTypes[selectedFile.type],
        screenName,
      }

      await zoomSdk
        .zmSystemBrowserCollaboration({
          fileUrl: shareFileData.fileUrl,
          messageText: `Upon joining, the email associated with your Google account will be granted ${valueToVerb(permission)} access`,
        })
        .then(() => {
          setShareFile(shareFileData)
          zoomSdk.sendAppToBackground() // we don't want to see the app
        })
        .catch((e) => {
          if (
            e?.message === 'The app is in collaborate mode.' ||
            e?.message === 'No Permission for this API.'
          ) {
            dispatch(setDialog({ type: 'collaborationInProgress' }))
          } else {
            dispatch(closeDialog())
          }
        })
    }
  }

  return (
    <FilePermissions
      options={googlePermissionsOptions}
      onChange={setPermission}
      handleGrant={handleGrant}
      onClose={onClose}
      fileName={fileName!}
      fileUrl={fileUrl}
      icon={Icon}
      app={'Google'}
    />
  )
}

export default FileShareDialogGoogle
